import React from 'react';
import Select from 'react-select';

class SmartMultiSelectClearable extends React.Component {
    constructor(props) {
        super(props);
        this.SmartSelectRef = React.createRef();
        let options = [];
        this.props.colDef.cellEditorParams.values.forEach(
            (item) => {
                options.push({ label: item, value: item });
            }
        );

        let selectedValue = '';
        if ((this.props.value != null) && (this.props.value != '')) {
            let valueItems = [];
            if (this.props.value.includes(',')) {
                valueItems = this.props.value.split(',');
            } else {
                valueItems.push(this.props.value);
            }
            selectedValue = options.filter(opt => valueItems.find(item => opt.label == item));
        }

        this.state = {
            values: options,
            selectedValue: selectedValue
        };
    };

    isPopup() {
        return typeof this.props.isPopup === "boolean" ? this.props.isPopup : false;
    }

    componentWillReceiveProps(nextProps) {
        this.setState({ values: nextProps.values });
    };

    getPlacement() {
        const totalRowCount = this.props.node?.parent?.allChildrenCount;
        return ((totalRowCount <= 5) ||
            ((this.props.rowIndex + 1) <= (totalRowCount / 2)))
            ? "bottom" : "top";
    }

    getValue() {
        return this.state?.selectedValue == null ? '' : (this.state?.selectedValue.length > 0) ? this.state?.selectedValue?.map(item => { return item?.value; }).join(',') : '';
    };

    onSmartMultiSelect = (opt) => {
        if (opt == null && opt == '') {
            this.props.node.setDataValue(
                this.props.colDef.field,
                opt.map(item => { return item.value; }).join(',')
            );
        }
        this.setState({ selectedValue: opt });
    }
    render() {
        return (
            <Select
                options={this.state.values}
                isMulti
                closeMenuOnSelect={false}
                maxMenuHeight="400px"
                defaultValue={this.state.selectedValue}
                onChange={this.onSmartMultiSelect}
                menuPlacement={this.getPlacement()}
                classNamePrefix='multi-filter'
            />
        );
    };
};

export default SmartMultiSelectClearable;